export default __webpack_public_path__ + "static/media/hands_category_img.140ca6c1.png";